module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/pdp_classicHover-f35aa817f5f8f8bc13999dd124823465.jpg";